import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export default {
  items: function items(state) {
    return state.items;
  },
  products: function products(state) {
    return state.products;
  }
};